<div class="comments-container">
    <!-- New Comment Input (at top) -->
    <div class="comment-input-container">
        <input
            type="text"
            [(ngModel)]="newCommentText"
            (keydown)="onKeyDown($event)"
            placeholder="Add a comment..."
            class="comment-input"
            [disabled]="isSubmitting"
        />
        <button class="comment-submit" (click)="submitComment()" [disabled]="!newCommentText.trim() || isSubmitting">
            <i *ngIf="!isSubmitting" class="fa-solid fa-paper-plane"></i>
            <i *ngIf="isSubmitting" class="fa-solid fa-spinner fa-spin"></i>
        </button>
    </div>

    <!-- Comments List -->
    <div class="comments-list" #commentsContainer>
        <div *ngIf="isLoading" class="comments-loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
        </div>

        <div *ngIf="!isLoading && comments.length === 0" class="comments-empty">
            <span>No comments yet</span>
        </div>

        <div *ngFor="let comment of sortedComments" class="comment-item" [class.comment-item--system]="isSystemComment(comment)">
            <div class="comment-text">
                <i *ngIf="isSystemComment(comment)" class="fa-solid fa-circle-info system-icon"></i>
                {{ comment.text }}
            </div>
            <div class="comment-meta">
                <span class="comment-author">{{ comment.createdByName }}</span>
                <span class="comment-date">{{ formatDate(comment.createdAt) }}</span>
                <button class="comment-delete" (click)="deleteComment(comment)" title="Delete">
                    <i class="fa-solid fa-trash-can"></i>
                </button>
            </div>
        </div>
    </div>
</div>

